import { inject } from "@angular/core";
import { ResolveFn, Router } from "@angular/router";

export interface IExtrasStateData {
    extrasStateResolver: Record<string, any>;
}
export const ExtrasStateResolver: ResolveFn<
    IExtrasStateData['extrasStateResolver']
> = (route, state) => {
    const router = inject(Router);
    const navigation = router.getCurrentNavigation();
    return navigation?.extras.state ?? {};
};